import store from '@/store/store';
import { Stage } from '@/types';
import {
  getAndStoreFeatureFlags,
  parseConsentCookie,
  readCookieValue,
  SplitSupportedEnvironment,
  SplitSupportedPlatform,
} from '@smg-real-estate/vue-experiments';
import { favouritesFlagSet } from './splitIoFlags';

export function isConsentGranted(): boolean {
  const consentCookieValue = readCookieValue(document.cookie, 'OptanonConsent');
  const consentCookie = parseConsentCookie(consentCookieValue);

  const isAlertBoxClosed = !!document.cookie.match(
    new RegExp('(^| )' + 'OptanonAlertBoxClosed' + '=([^;]+)'),
  );

  const isPersonalizationConsent = consentCookie?.groups.includes('C0002:1');

  return !!(isAlertBoxClosed && isPersonalizationConsent);
}

export const splitIoHandler = async (): Promise<void> => {
  const platform = import.meta.env.VUE_APP_PLATFORM as unknown as SplitSupportedPlatform;

  const splitEnvironment =
    import.meta.env.VUE_APP_ENVIRONMENT?.toLowerCase() === Stage.Prod
      ? SplitSupportedEnvironment.PROD
      : SplitSupportedEnvironment.TEST;

  // Send request to experiments API & store the result in the store
  await getAndStoreFeatureFlags(store, favouritesFlagSet, {
    platform,
    env: splitEnvironment,
  });
};
